// new - only date is passed
export const TimeZone = (dateTime?: Date): string => {
   const date = dateTime || new Date()
   return date.toLocaleDateString('en-CA')
}

// export const TimeZone = (dateTime?: Date): string => {
//   if (!dateTime) {
//     dateTime = new Date() // Fallback to the current date
//   }

//   const localOffset = dateTime.getTimezoneOffset() * 60000 // Convert offset to milliseconds
//   const localDate = new Date(dateTime.getTime() - localOffset) // Adjust to local timezone
//   return localDate.toISOString().slice(0, 19) // Keep only date and time (exclude 'Z' for UTC indicator)
// }
